<script setup lang="ts">
import { articleService } from '@/api/services/article-service'
import BaseLayout from '@/components/base/BaseLayout.vue'
import type { ArticleDetail } from '@/types/article.types'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const postId = route.params.id as unknown as number

const post = ref<ArticleDetail>()

onMounted(async () => {
  post.value = await articleService.getArticleDetail(postId)
})

const formatDate = (date: number) => {
  const dateObj = new Date(date)
  return dateObj.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' })
}
</script>

<template>
  <BaseLayout>
    <div v-if="post" class="post-detail-container">
      <div class="post-detail-title title-md white">{{ post.title }}</div>
      <div class="post-detail-meta">
        <div class="post-detail-meta-created-at body-sm gray-600">
          {{ formatDate(post.createdAt) }}
        </div>
      </div>
      <div class="post-detail-content" v-html="post.content"></div>
    </div>
  </BaseLayout>
</template>

<style scoped>
.post-detail-container {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.post-detail-meta {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12px;
}

.post-detail-content {
  background-color: var(--gray-800);
  padding: 20px;
  min-height: 70vh;
  border-radius: 12px;
  margin-top: 20px;
}

/* v-html 컨텐츠 내부의 모든 요소에 max-width 적용 */
.post-detail-content :deep(*) {
  max-width: 100%;
  color: var(--white);
}

.editor-container {
  height: auto;
  margin-top: 20px;
}

@media (max-width: 1365px) {
  .post-detail-container {
    padding: 16px 20px;
  }

  .post-detail-content :deep(*) {
    max-width: 100%;
  }
}
</style>
